import {useRef} from 'react'

export const useTap = () => {
  const lastTap = useRef(0)
  const timeout = useRef<any>(null)

  const handleTap = (singleTap: () => void, doubleTap: () => void) => {
    const now = Date.now()
    const delay = 250

    if (now - lastTap.current < delay) {
      clearTimeout(timeout.current)
      doubleTap()
    } else {
      timeout.current = setTimeout(() => {
        singleTap()
      }, delay)
    }

    lastTap.current = now
  }

  return handleTap
}
